import {
  createHoliday,
  getHolidaysList,
  updateHoliday,
  getHolidayById,
  deleteHoliday,
  getCalendarHolidays,
} from "@/http/system/holidayManagement.js";

export default {
  namespaced: true,
  state: {
    holidaysList: [],
    holidayById: {},
    calendarHolidays: null,
  },
  actions: {
    async createHolidayAction(_, payload) {
      try {
        const res = await createHoliday(payload);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateHolidayAction(_, payload) {
      try {
        const res = await updateHoliday(payload.id, payload.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteHolidayAction(_, payload) {
      try {
        const res = await deleteHoliday(payload);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getHolidaysListAction({ commit }) {
      try {
        const resp = await getHolidaysList();
        commit("SET_HOLIDAYS_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getHolidayByIdAction({ commit }, id) {
      try {
        const resp = await getHolidayById(id);
        commit("SET_HOLIDAYS_BY_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCalendarHolidaysAction({ commit }, data) {
      try {
        const resp = await getCalendarHolidays(data.fromDate, data.toDate, data.userId);
        commit("SET_CALENDAR_HOLIDAYS", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_HOLIDAYS_LIST(state, payload) {
      state.holidaysList = payload;
    },
    SET_HOLIDAYS_BY_ID(state, payload) {
      state.holidayById = payload;
    },
    SET_CALENDAR_HOLIDAYS(state, payload) {
      state.calendarHolidays = payload;
    },
  },
};
